import React from 'react';

interface PolygonIconProps {
  width: number;
  height: number;
  customColorTheme: string;
}

export const PolygonIcon = (props: PolygonIconProps) => {
  //
  return (
    <svg
      {...props}
      className="svg-icon"
      style={{ width: props.width, height: props.height }}
    >
      <svg className="analysis-instructions__draw-icon">
        <svg className="svg-icon">
          <svg id="icon-analysis-draw" viewBox="0 0 145 101">
            <title>Analysis Draw</title>
            <g>
              <path
                fill={props.customColorTheme}
                d="M135.726,62.687 C135.726,62.687 134.274,65.313 134.274,65.313 C134.274,65.313 52.274,12.313 52.274,12.313 C52.274,12.313 53.726,9.687 53.726,9.687 C53.726,9.687 135.726,62.687 135.726,62.687 Z"
                fillRule="evenodd"
              ></path>
              <path
                fill={props.customColorTheme}
                d="M105.726,90.687 C105.726,90.687 104.274,93.313 104.274,93.313 C104.274,93.313 42.274,83.313 42.274,83.313 C42.274,83.313 43.726,80.687 43.726,80.687 C43.726,80.687 105.726,90.687 105.726,90.687 Z"
                fillRule="evenodd"
              ></path>
              <path
                fill={props.customColorTheme}
                d="M105.153,92.235 C105.153,92.235 102.760,90.425 102.760,90.425 C102.760,90.425 134.847,60.765 134.847,60.765 C134.847,60.765 137.240,62.575 137.240,62.575 C137.240,62.575 105.153,92.235 105.153,92.235 Z"
                fillRule="evenodd"
              ></path>
              <path
                fill={props.customColorTheme}
                d="M43.793,81.207 C43.793,81.207 44.153,82.235 44.153,82.235 C44.153,82.235 41.760,80.425 41.760,80.425 C41.760,80.425 26.847,37.765 26.847,37.765 C26.847,37.765 28.207,38.793 28.207,38.793 C28.207,38.793 27.847,37.765 27.847,37.765 C27.847,37.765 30.240,39.575 30.240,39.575 C30.240,39.575 45.153,82.235 45.153,82.235 C45.153,82.235 43.793,81.207 43.793,81.207 Z"
                fillRule="evenodd"
              ></path>
              <circle
                fill={props.customColorTheme}
                cx="49"
                cy="9"
                r="9"
              ></circle>
              <circle fill="#FFFFFF" cx="49" cy="9" r="6"></circle>
              <circle
                fill={props.customColorTheme}
                cx="136"
                cy="65"
                r="9"
              ></circle>
              <circle fill="#FFFFFF" cx="136" cy="65" r="6"></circle>
              <circle
                fill={props.customColorTheme}
                cx="106"
                cy="92"
                r="9"
              ></circle>
              <circle fill="#FFFFFF" cx="106" cy="92" r="6"></circle>
              <circle
                fill={props.customColorTheme}
                cx="43"
                cy="82"
                r="9"
              ></circle>
              <circle fill="#FFFFFF" cx="43" cy="82" r="6"></circle>
              <circle
                fill={props.customColorTheme}
                cx="29"
                cy="39"
                r="9"
              ></circle>
              <circle fill="#FFFFFF" cx="29" cy="39" r="6"></circle>
              <path
                fill="#555555"
                d="M13.896,14.212 C13.896,14.212 15.096,13.010 15.096,13.010 C15.096,13.010 23.668,21.597 23.668,21.597 C23.668,21.597 22.468,22.799 22.468,22.799 C22.468,22.799 13.896,14.212 13.896,14.212 ZM5.324,19.879 C5.324,19.879 13.896,11.293 13.896,11.293 C13.896,11.293 15.096,12.495 15.096,12.495 C15.096,12.495 6.524,21.081 6.524,21.081 C6.524,21.081 5.324,19.879 5.324,19.879 ZM5.838,16.617 C4.467,17.990 4.809,17.819 3.438,19.192 C3.438,19.192 1.038,16.617 1.038,16.617 C-0.334,15.414 -0.334,13.182 1.038,11.808 C1.038,11.808 5.838,7.000 5.838,7.000 C7.210,5.626 9.267,5.626 10.638,7.000 C10.638,7.000 13.210,9.404 13.210,9.404 C11.839,10.606 12.010,10.434 10.638,11.808 C10.638,11.808 5.838,16.617 5.838,16.617 ZM16.811,28.466 C16.811,28.466 15.610,29.668 15.610,29.668 C15.610,29.668 7.038,21.081 7.038,21.081 C7.038,21.081 8.238,19.879 8.238,19.879 C8.238,19.879 16.811,28.466 16.811,28.466 ZM11.667,16.445 C11.667,16.445 20.239,25.031 20.239,25.031 C20.239,25.031 19.039,26.233 19.039,26.233 C19.039,26.233 10.467,17.647 10.467,17.647 C10.467,17.647 11.667,16.445 11.667,16.445 ZM24.011,30.011 C24.011,30.011 17.325,29.324 17.325,29.324 C17.325,29.324 23.325,23.314 23.325,23.314 C23.325,23.314 24.011,30.011 24.011,30.011 Z"
                fillRule="evenodd"
              ></path>
            </g>
          </svg>
        </svg>
      </svg>
    </svg>
  );
};
